import React from 'react';
import Shimmer from './Shimmer';
import SkeletonElement from './SkeletonElement';

const SkeletonArticle = ({ theme }) => {

    const themeClass = theme || 'light'

    return (
        <div className={`skeleton-wrapper ${themeClass}`}>
            <div className="skeleton-article">
                <div className="skeleton-profile row">
                    <div className='col-1'>
                        <SkeletonElement type='avatar' />
                    </div>

                    <div className='col-11'>
                        <SkeletonElement type='title' />
                        <SkeletonElement type='time' />
                    </div>
                </div>
                <div>
                    <SkeletonElement type='text' />
                    <SkeletonElement type='thumbnail' />
                </div>

                <div className="row justify-content-between">

                    <div className="col-md-4">
                        <SkeletonElement  type='like' />
                    </div>
                    <div className="d-flex col-md-4">
                        <SkeletonElement  type='like' />
                    </div>
                </div>
                
                <div className="row ">
                <div className="d-flex col-md-12">
                <SkeletonElement type='text' />
                    </div>
                </div>
                {/* <SkeletonElement type='title'/>
                <SkeletonElement type='text'/>
                <SkeletonElement type='title'/>
                <SkeletonElement type='title'/> */}
            </div>
            <Shimmer />
        </div>
    );
};

export default SkeletonArticle;